import { useEffect, useState } from 'react';
import ProgressTransferModal from './components/ProgressTransferModal';
import ProgressTransferConfirmationModal from './components/ProgressTransferConfirmationModal';
import ProgressTransferVerifiedModal from './components/ProgressTransferVerifiedModal';
import { useSendProgressTransferRequest, useVerifyProgressTransferRequest } from './hooks/useProgressTransfer';
import ProgressTransferBanner from './components/ProgressTransferBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const ProgressTransferContainer = ({
  handleClose,
  isOpen,
  onCloseVerification,
  userAwards,
  verify,
  trackEvent,
  ErrorComponent,
  currentUserEmail
}) => {
  const [state, setState] = useState({
    destinationEmail: '',
    shouldShowConfirmationModal: false
  });
  const {
    destinationEmail,
    shouldShowConfirmationModal
  } = state;
  const [sendProgressTransferRequest, {
    loading: isRequestingProgressTransfer,
    error: progressTransferError,
    data: transferRequestData
  }] = useSendProgressTransferRequest();
  const [, {
    error: progressTransferVerificationError,
    data: verificationData
  }] = useVerifyProgressTransferRequest();
  const progressTransferRequestCompleted = !!transferRequestData && !progressTransferError;
  const progressTransferVerified = !!verificationData && !progressTransferVerificationError;
  const recentError = progressTransferError || progressTransferVerificationError;
  useEffect(() => {
    if (!isOpen) {
      setState({
        destinationEmail: '',
        shouldShowConfirmationModal: false
      });
    }
  }, [isOpen]);
  const handleSubmitDestinationAccount = email => {
    setState(prevState => Object.assign({}, prevState, {
      destinationEmail: email,
      shouldShowConfirmationModal: true
    }));
  };
  const handleConfirmProgressTransfer = () => {
    void sendProgressTransferRequest({
      variables: {
        newUserEmail: destinationEmail
      }
    });
  };
  const handleCloseConfirmationModal = () => {
    setState(prevState => Object.assign({}, prevState, {
      shouldShowConfirmationModal: false
    }));
    handleClose();
  };
  const handleCloseVerifiedModal = () => {
    onCloseVerification === null || onCloseVerification === void 0 || onCloseVerification();
    handleClose();
  };
  if (verify) {
    return /*#__PURE__*/_jsx(ProgressTransferVerifiedModal, {
      ErrorComponent: ErrorComponent,
      error: recentError,
      onConfirm: handleCloseVerifiedModal,
      progressTransferVerified: progressTransferVerified,
      trackEvent: trackEvent
    });
  }
  if (progressTransferRequestCompleted) {
    trackEvent({
      action: 'certswap-request-succeeded'
    });
    return /*#__PURE__*/_jsx(ProgressTransferBanner, {
      destinationEmail: destinationEmail
    });
  }
  if (!isOpen) {
    return null;
  }
  if (shouldShowConfirmationModal) {
    return /*#__PURE__*/_jsx(ProgressTransferConfirmationModal, {
      ErrorComponent: ErrorComponent,
      certificates: userAwards,
      closeModal: handleCloseConfirmationModal,
      destinationEmail: destinationEmail,
      error: recentError,
      loading: isRequestingProgressTransfer,
      onConfirm: handleConfirmProgressTransfer,
      sourceEmail: currentUserEmail,
      trackEvent: trackEvent
    });
  }
  return /*#__PURE__*/_jsx(ProgressTransferModal, {
    currentEmail: currentUserEmail,
    onConfirm: handleSubmitDestinationAccount,
    onReject: handleClose,
    trackEvent: trackEvent
  });
};
export default ProgressTransferContainer;